import { makeStyles, createStyles, Theme } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';

type Tprops = {
  item: any;
  detailItemFlg: boolean;
  setDetailItemFlg: React.Dispatch<React.SetStateAction<boolean>>;
  setCreateModal: React.Dispatch<React.SetStateAction<boolean>>;
  setUpdateModal: React.Dispatch<React.SetStateAction<boolean>>;
  setDeleteModal: React.Dispatch<React.SetStateAction<boolean>>;
  handleClose: () => void;
};

export const ButtonList: React.FC<Tprops> = (props: Tprops) => {
  const {
    item,
    detailItemFlg,
    setDetailItemFlg,
    setCreateModal,
    setUpdateModal,
    setDeleteModal,
    handleClose
  } = props;

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      popoverButton: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        cursor: 'pointer',
        borderBottom: '1px solid rgb(245, 245, 245)',
        padding: '20px 30px',
        '&:hover': {
          backgroundColor: '#CFCFCF'
        }
      }
    })
  );

  const classes = useStyles();

  return (
    <>
      <div style={{ width: 200 }}>
        {!detailItemFlg && (
          <div
            className={classes.popoverButton}
            onClick={() => {
              handleClose();
              setDetailItemFlg(true);
              setCreateModal(true);
            }}
          >
            <div style={{ marginRight: 8 }}>
              <AddIcon />
            </div>
            <div>小項目追加</div>
          </div>
        )}
        <div
          className={classes.popoverButton}
          onClick={() => {
            handleClose();
            setUpdateModal(true);
          }}
        >
          <div style={{ marginRight: 8 }}>
            <EditIcon />
          </div>
          編集
        </div>
        <div
          className={classes.popoverButton}
          onClick={() => {
            handleClose();
            setDeleteModal(true);
          }}
        >
          <div style={{ marginRight: 8 }}>
            <DeleteIcon />
          </div>
          削除
        </div>
      </div>
    </>
  );
};
